import React from 'react'

import ProductsPage from '../components/ProductsPage/ProductsPage'



const Products = () => {
  return (
    <>
    <ProductsPage/>
 
    </>
  )
}

export default Products
